import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-100">用户评价</h2>
          <p className="text-sm text-foreground-500 mt-3">追剧爱好者们的真实反馈</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {commentsData.map((comment, i) => (
            <div key={i} className="p-5 rounded-xl bg-background-50 border border-background-200/50">
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, j) => (
                  <i
                    key={j}
                    className={`text-xs ${j < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-600'}`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-300 leading-relaxed line-clamp-4">{comment.content}</p>
              <div className="flex items-center gap-2 mt-4 pt-3 border-t border-background-200/40">
                <div className="w-8 h-8 rounded-full bg-primary-500/20 flex items-center justify-center">
                  <span className="text-xs font-bold text-primary-400">{comment.author.charAt(0)}</span>
                </div>
                <div>
                  <p className="text-xs font-semibold text-foreground-200">{comment.author}</p>
                  <p className="text-[10px] text-foreground-500">{comment.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}